import "./style.css";
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Button({
	title,
	buttonClass,
	containerClass,
	buttonTextClass,
	buttonText,
	iconContainerClass,
	icon,
}) {
	return (
		<button title={`${title}`} className={`${buttonClass}`}>
			<div className={`${containerClass}`}>
				<div className={`${iconContainerClass}`}>
					<FontAwesomeIcon icon={icon} />
				</div>
				{buttonText ? (
					<p className={`${buttonTextClass}`}>{buttonText}</p>
				) : null}
			</div>
		</button>
	);
}
